import React from 'react';

// Components
import HtmlPart from './HtmlPart';

// functions
import { scopeCssString } from '../utilities/scopeCssString';

function HtmlPartWithCss({ htmlString, cssString, escapeId }, ...rest) {
  const scopedStyleTag = `<style>${scopeCssString(cssString, `#${escapeId}`)}</style>`;
  return (
    <HtmlPart
      htmlString={`${scopedStyleTag}${htmlString}`}
      {...rest}
      id={escapeId || false}
      ommitBaseStyles
    />
  );
}

export default HtmlPartWithCss;



// WEBPACK FOOTER //
// ./src/parts/HtmlPartWithCss.js